import React, { Component } from 'react'

export default class text extends Component {
    render() {
        
        return (
            <div style= {{ zIndex: '1'}}>
                        <h1 style= {{textAlign: 'center',paddingTop: '0px', letterSpacing: '-1px',fontSize: '25px', color:'black', width: '100%', marginBottom: '-30px'}}>Los mejores profesionales de Santiago en LibérameApp</h1>
            </div>
            
        )
    }
}
